export default __webpack_public_path__ + "static/media/img3.5abf0695.jpg";